<div class="card-skeleton">
  <div class="header">
    <ngx-skeleton-loader
      class="title"
      appearance="line"
      [theme]="{
        width: '55%',
        height: '100%',
        'border-radius': '4px',
        'margin-bottom': '0'
      }"
    ></ngx-skeleton-loader>
  </div>

  <ngx-skeleton-loader
    class="amount"
    appearance="line"
    [theme]="{
      width: '35%',
      height: '30%',
      'border-radius': '4px',
      'margin-bottom': '0'
    }"
  ></ngx-skeleton-loader>
 
  <div class="footer">
    <ngx-skeleton-loader
      appearance="line"
      [theme]="{
        width: '35%',
        height: '50%',
        'border-radius': '4px',
        'margin-bottom': '0'
      }"
    ></ngx-skeleton-loader>
  </div>
</div>